<template>
  <el-dialog
    :visible.sync="showDialog"
    :append-to-body="true"
    width="375px"
    custom-class="dialog-positive"
    title="積極接單規則與說明"
    @close="$emit('change', false)"
  >
    <div class="intro-positive-title">
      <img src="~@/assets/image/icons/light.png" alt="">
      開啟此按鈕即表示您當前可以接單
    </div>
    <div class="intro-positive-content">
      <div style="font-weight: 500;">如果打開【當前可接單】按鈕，表示您現在可以接單，若您有以下行為，系統將自動關閉可接單狀態</div>
      <ul>
        <li>
          <p>他人當日首次向您發送訊息，您1分鐘內未及時回覆相關訊息</p>
          <p><span>小叮嚀：如果遇到有違規行為的用戶，請直接封鎖或檢舉對方，封鎖用戶後該條消息不會影響在線狀態～</span></p>
        </li>
        <li>
          <p>超過10分鐘未接單</p>
          <p><span>小叮嚀：讓用戶等待太久，可不是一個好的約玩體驗喔～</span></p>
        </li>
      </ul>
      <div class="split"></div>
      <div>請注意：若您被系統關閉可接單狀態，則有一段時間不可開啟接單狀態，請謹慎對待～</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  model: {
    prop: 'show',
    event: 'change',
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      showDialog: false,
    }
  },
  watch: {
    show(show) {
      this.showDialog = show
    },
  }
}
</script>

<style lang="scss">
  .dialog-positive {
    border-radius: 15px;
    overflow: hidden;
    .el-dialog__header {
      padding: 18px 20px 17px;
      border-bottom: 1px solid $color-split;
      color: $color-gray-1;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
    .el-dialog__body {
      padding: 20px;
      min-height: 157px;
    }
  }
</style>

<style lang="scss" scoped>
  .intro-positive {
    &-title {
      overflow: hidden;
      line-height: 24px;
      color: $color-gray-1;
      font-size: 14px;
      font-weight: 500;
      img {
        width: 24px;
        height: 24px;
        float: left;
        margin-right: 11px;
      }
    }
    &-content {
      margin-top: 20px;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      text-align: left;
      ul {
        li {
          position: relative;
          padding: 16px 0 0 16px;
          &::after {
            content: '';
            display: block;
            position: absolute;
            left: 0;
            top: 16px;
            width: 16px;
            height: 20px;
            line-height: 20px;
            color: $color-gray-1;
          }
          &:nth-child(1)::after {
            content: '1.'
          }
          &:nth-child(2)::after {
            content: '2.'
          }
        }
        p {
          & + p {
            margin-top: 8px;
          }
          span {
            color: $color-orange;
            opacity: 0.9;
          }
        }
      }
      .split {
        width: 100%;
        height: 1PX;
        background: $color-button;
        margin: 16px 0;
      }
    }
  }
</style>
